import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useApp } from '../App';

export default function AppShell() {
  const { currentUser, handleLogout } = useApp();
  const role = (currentUser?.role || '').toLowerCase();
  const canViewWebsiteInbox = ['owner', 'admin', 'webmaster_admin', 'superadmin'].includes(role);
  const canViewAuditTrail = ['owner', 'admin', 'security_auditor', 'superadmin'].includes(role);

  return (
    <div className="app-layout">
      <aside className="app-sidebar">
        <Link className="brand sidebar-brand" to="/app/dashboard">
          <img className="brand-mark" src="/SROIK-LOGO.PNG" alt="Sroik" />
        </Link>

        <nav className="sidebar-nav" aria-label="App navigation">
          <NavLink
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            to="/app/dashboard"
          >
            <span className="sidebar-icon">&#9627;</span>
            Dashboard
          </NavLink>
          <NavLink
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            to="/app/recommendations"
          >
            <span className="sidebar-icon">&#10003;</span>
            Recommendations
          </NavLink>
          <NavLink
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            to="/app/assistant"
          >
            <span className="sidebar-icon">&#128172;</span>
            Assistant
          </NavLink>
          <NavLink
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            to="/app/accounts"
          >
            <span className="sidebar-icon">&#9881;</span>
            Accounts
          </NavLink>
          <NavLink
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            to="/app/users"
          >
            <span className="sidebar-icon">&#128101;</span>
            Team
          </NavLink>
          {canViewAuditTrail && (
            <Link className="sidebar-link" to="/app/security#audit-log">
              <span className="sidebar-icon">&#128221;</span>
              Audit Trail
            </Link>
          )}
          <NavLink
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            to="/app/security"
          >
            <span className="sidebar-icon">&#9679;</span>
            Settings
          </NavLink>
          {canViewWebsiteInbox && (
            <NavLink
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
              to="/app/website-inbox"
            >
              <span className="sidebar-icon">&#9993;</span>
              Website Inbox
            </NavLink>
          )}
        </nav>

        <div className="sidebar-footer">
          <p className="sidebar-user" title={currentUser?.email}>{currentUser?.email}</p>
          <p className="sidebar-role">{currentUser?.role || 'viewer'}</p>
          <button className="sidebar-logout" onClick={handleLogout} type="button">Sign out</button>
        </div>
      </aside>

      <div className="app-content">
        <Outlet />
      </div>
    </div>
  );
}
